<template>
  <BaseForm formColor="panel panel-primary" formIcon="fa fa-edit" formSubtitulo="Relatório de compras"
            col-md="col-md-3" offset="offset-4">
    <template v-slot:inputForm>
      <form @submit.prevent="submitIncluirForm">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <FloatLabel variant="on">
                <DatePicker id="data_inicio" v-model="dado.data_inicio" showIcon iconDisplay="input"
                            size="small" style="width: 100%" appendTo="body" ref="dataInicial" dateFormat="dd/mm/yyyy"/>
                <label for="data_inicio"><strong>Data inicial: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <FloatLabel variant="on">
                <DatePicker id="data_fim" v-model="dado.data_fim" showIcon iconDisplay="input"
                            size="small" style="width: 100%" appendTo="body" ref="dataFim" dateFormat="dd/mm/yyyy"/>
                <label for="data_fim"><strong>Data final: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.fornecedor"
                    inputId="fornecedor"
                    :options="fornecedores"
                    optionLabel="razao_social"
                    optionValue="id"
                    size="small"
                    appendTo="body"
                    filter
                    style="width: 100%"
                >
                  <template #emptyfilter>
                    Nenhum resultado encontrado
                  </template>
                </Select>
                <label for="fornecedor"><strong>Fornecedor: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.usuario"
                    inputId="usuario"
                    :options="usuarios"
                    optionLabel="username"
                    optionValue="id"
                    size="small"
                    appendTo="body"
                    filter
                    style="width: 100%"
                >
                  <template #emptyfilter>
                    Nenhum resultado encontrado
                  </template>
                </Select>
                <label for="usuario"><strong>Usuário: </strong></label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="float-right">
            <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
          </div>
        </div>
        <br>
      </form>
    </template>
  </BaseForm>
</template>

<script>

import {defineComponent} from "vue";
import BaseForm from "@/components/base/BaseForm.vue";
import {apiRequest, denormalizeDates} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";

export default defineComponent({
  name: "RelatorioCompras",
  components: {
    BaseForm,
  },
  data() {
    return {
      fornecedores: [],
      usuarios: [],
      dado: {
        data_inicio: null,
        data_fim: null,
        fornecedor: "",
        usuario: "",
      },
      campoVazio: [],
    }
  },
  methods: {
    async getFornecedores() {
      const resultado = await apiRequest("GET", apiUrl.fornecedores.createList);
      if (resultado.success) {
        this.fornecedores = resultado.data.results;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async getUsuarios() {
      const resultado = await apiRequest("GET", apiUrl.usuarios.createList);
      if (resultado.success) {
        this.usuarios = resultado.data.results;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async submitIncluirForm() {
      denormalizeDates(this.dado, ['data_inicio', 'data_fim']);
      const resultado = await apiRequest("POST", apiUrl.compras.relatorio, this.dado);
      if (resultado.success) {
        this.$router.push({
          path: '/relatorio',
          state: resultado.data
        });
      } else {
        this.$toastMessage("warn", "Atenção", resultado.error.detail);
        console.error("Erro:", resultado.error);
        this.campoVazio = Object.keys(resultado.error);
      }
    },
  },
  mounted() {
    this.getFornecedores();
    this.getUsuarios();
    Inputmask("99/99/9999").mask(this.$refs.dataInicial.$el.querySelector("input"));
    Inputmask("99/99/9999").mask(this.$refs.dataFim.$el.querySelector("input"));
  }
})
</script>
